import Config from '../definitions/Config';
import fetchJSON from './fetchJSON';


/**
 * Fetch a sponsored placement post from the Sponsored Placements CORE service.
 * @param {string} slug - a slug matching a Sponsored Placement post in the CMS
 * @param {string} province - a two-letter province code OR 'all'
 * @returns {Promise} resolves to an array of sponsored placements
 */
async function fetchSponsoredPlacement(slug, province) {
    const fetchResult = await fetchJSON({
        url: Config.SPONSORED_PLACEMENTS_API_URL,
        params: {
            slug,
            province,
        },
    }, 'fetchSponsoredPlacement');

    return fetchResult?.data?.sponsoredProducts;
}

export default fetchSponsoredPlacement;
